import { render } from "./MinistryOfHealthSection.vue?vue&type=template&id=08a06f16&scoped=true"
import script from "./MinistryOfHealthSection.vue?vue&type=script&lang=js"
export * from "./MinistryOfHealthSection.vue?vue&type=script&lang=js"

import "./MinistryOfHealthSection.vue?vue&type=style&index=0&id=08a06f16&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a06f16"]])

export default __exports__